"use client";
import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
function SampleNextArrow(any: { className: any; style: any; onClick: any }) {
  const { className, style, onClick } = any;
  return (
    <div
      className={className}
      style={{
        ...style,
        position: "absolute",
        right: "2%",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(any: { className: any; style: any; onClick: any }) {
  const { className, style, onClick } = any;
  return (
    <div
      className={className}
      style={{ ...style, position: "absolute",
      left: "1%",
      zIndex:'9'
    }}
      onClick={onClick}
    />
  );
}
const ProductSlider: React.FC<any> = ({ children }) => {
  const settings = {
    dots: false,
    arrow: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplaySpeed: 2000,
    autoplay: true,
    loop: true,
    nextArrow: (
      <SampleNextArrow
        className={undefined}
        style={undefined}
        onClick={undefined}
      />
    ),
    prevArrow: (
      <SamplePrevArrow
        className={undefined}
        style={undefined}
        onClick={undefined}
      />
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="slider-container">
      <Slider {...settings}>{children}</Slider>
    </div>
  );
};

export default ProductSlider;
